import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { ProtectedAdminRoute } from '~/util/ProtectedAdminRoute';
import { ProtectedRoute } from '~/util/ProtectedRoute';
import { logError } from '~/util';
import { MfaEnrollment } from '~/components/Auth/Mfa/MfaEnrollment';
import { Dashboard } from './Patients/Dashboard';
import { Reminders } from './Patients/Reminders';
import { User } from './User';
import { Patients } from './Patients';
import { Error404 } from './Error';
import { Login } from './Auth/Login';
import { Mfa } from './Auth/Mfa';
import { Forgot } from './Auth/Forgot';
import { Reset } from './Auth/Reset';
import { Expired } from './Auth/Expired';
import { Logout } from './Auth/Logout';
import { Admin } from './Admin';
import { PageFallback } from './PageFallback';
import { Resources } from './Resources';

export function Pages() {
    return (
        <ErrorBoundary FallbackComponent={PageFallback} onError={logError}>
            <Switch>
                <ProtectedAdminRoute path="/admin" component={Admin} />
                <ProtectedRoute path="/dashboard" component={Dashboard} exact />
                <ProtectedRoute path="/reminders" component={Reminders} exact />
                <ProtectedRoute path="/user" component={User} />
                <ProtectedRoute path="/patients" component={Patients} />
                <ProtectedRoute path="/resources" component={Resources} />

                <Route path="/mfa" component={Mfa} exact />
                <Route path="/mfa-enrollment" component={MfaEnrollment} exact />
                <Route path="/forgot" component={Forgot} exact />
                <Route path="/reset" component={Reset} exact />
                <Route path="/reset/expired/:token" component={Expired} exact />
                <Route path="/logout" component={Logout} exact />
                <Route path="/" component={Login} exact />
                <Route path="*" component={Error404} />
            </Switch>
        </ErrorBoundary>
    );
}
